var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    transform: "translate(-1819.109 -1863.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_37",
    "data-name": "Mask Group 37",
    transform: "translate(25755.109 14373.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(-23949 -12908.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "list_FILL0_wght400_GRAD0_opsz48",
    d: "M120.941,388.623a.9.9,0,0,1-.673-.274.931.931,0,0,1-.268-.679.9.9,0,0,1,.274-.673.931.931,0,0,1,.678-.268.9.9,0,0,1,.673.274.931.931,0,0,1,.268.678.9.9,0,0,1-.274.673A.931.931,0,0,1,120.941,388.623Zm0-5.365a.9.9,0,0,1-.673-.274.931.931,0,0,1-.268-.678.9.9,0,0,1,.274-.673.931.931,0,0,1,.678-.268.9.9,0,0,1,.673.274.931.931,0,0,1,.268.679.9.9,0,0,1-.274.673A.931.931,0,0,1,120.941,383.258Zm0-5.365a.9.9,0,0,1-.673-.274.931.931,0,0,1-.268-.678.9.9,0,0,1,.274-.673.931.931,0,0,1,.678-.268.9.9,0,0,1,.673.274.932.932,0,0,1,.268.679.9.9,0,0,1-.274.673A.931.931,0,0,1,120.941,377.893Z",
    transform: "translate(-104 27.85)",
    fill: "#918f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "list_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "list_FILL0_wght400_GRAD0_opsz48",
    d: "M126.884,388.667v-1.9h12.958v1.9Zm0-5.383v-1.9h12.958v1.9Zm0-5.383V376h12.958v1.9Z",
    transform: "translate(-105.842 27.85)",
    fill: "#918f90"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.dab4ffb429e5b672621f5f3e004f50ac.svg";
export { ForwardRef as ReactComponent };